// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"ddf0fb08","128":"6c466656","312":"ec802b93","349":"cd528c4e","537":"e638c1ff","543":"9285e9ce","722":"313f47ba","756":"28091624","957":"ce575a13"}[chunkId] + ".chunk.css";
};